export default "__VITE_ASSET__B091ZeFZ__"